<template>
  <div>
    <section class="container is-6">
      <div class="columns is-desktop">
        <div class="column is-6">
          <p class="title is-4">Policyholder Validation</p>
          <br />
          <p>Please provide the following information so that we may verify that you are a bona fide Republic Indemnity Policyholder.</p>
        </div>
      </div>
      <div class="columns is-desktop">
        <div class="column is-6">
          <!--  Special case -->
          <div class="field">
            <label class="label">Policy Number</label>
            <div class="field has-addons">
              <div class="control is-expanded">
                <div class="is-fullwidth">
                  <input
                    v-model="policynbr.value"
                    class="input"
                    name="policynbr"
                    v-validate="policynbr.validate"
                  />
                  <span class="help is-danger">{{ errors.first('policynbr') }}</span>
                </div>
              </div>

              <div class="control">
                <b-button type="is-info" @click="isImageModalActive = true" icon-right="help"></b-button>
              </div>
            </div>
          </div>

          <b-modal :active.sync="isImageModalActive">
            <section>
              <img src="../assets/logo.png" />
              <img width="700" src="../assets/logo.png" />
            </section>
          </b-modal>

          <b-field
            :label="effdate.label"
            :type="{'is-danger': errors.has(effdate.name)}"
            :message="errors.first(effdate.name)"
          >
            <b-datepicker
              v-model="effdate.value"
              :name="effdate.name"
              v-validate="effdate.validate"
              pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
              placeholder="Click to select..."
              icon="calendar-today"
            ></b-datepicker>
          </b-field>

          <b-field
            :label="authcode.label"
            :type="{'is-danger': errors.has(authcode.name)}"
            :message="errors.first(authcode.name)"
          >
            <b-input
              v-validate="authcode.validate"
              :type="authcode.type"
              :name="authcode.name"
              v-model="authcode.value"
              password-reveal
            />
          </b-field>

          <b-field label="Country">
            <b-select v-model="country" placeholder="Country">
              <option
                v-for="option in countryList"
                :value="option.name"
                :key="option.name"
              >{{ option.name }}</option>
            </b-select>
          </b-field>

          <b-field label="State">
            <b-select v-model="state" placeholder="State">
              <option v-for="(key, value) in stateMap" :value="value" :key="value">{{ key }}</option>
            </b-select>
          </b-field>
          {{ this.state }}
          <div class="field">
            <b-checkbox v-model="webAgreement" v-validate="required">
              I agree with Republic's Website
              <a @click="isAgreement = true">Agreement</a>.
            </b-checkbox>
            <span class="help is-danger">{{ errors.first('webAgreement') }}</span>
          </div>
        </div>
      </div>

      <br />
      <div class="buttons">
        <b-button
          type="is-warning"
          :class="{ 'disabled' : formLoading || !isFormValid }"
          @click="onSubmitValidation"
        >Continue</b-button>
        <b-button type="is-light" :class="{ 'disabled' : formLoading }" @click="onCancel">Cancel</b-button>
        <!-- <b-button type="is-info" @click="isImageModalActive = true" icon-right="help">Policy Number</b-button> -->
      </div>
      <b-modal :active.sync="isAgreement">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="title is-4">Policyholder Agreement</p>
          </header>
          <section class="modal-card-body">
            <b>I CERTIFY THAT I AM A BONA FIDE PRINCIPAL, EMPLOYEE, OR REPRESENTATIVE OF AN ENTITY WHICH IS CURRENTLY A POLICYHOLDER WITH REPUBLIC INDEMNITY COMPANY OF AMERICA OR REPUBLIC INDEMNITY COMPANY OF CALIFORNIA ("REPUBLIC INDEMNITY").</b>
            <br />
            <br />
            <b>
              I AGREE to protect the confidentiality of the information retrieved from this World Wide Web site. I further agree to limit my use of this information to activites defined by the terms and conditions set forth in our insurance policy contract and its endorsements.
              <br />
              <br />I AGREE to accept responsiblity for controlling access of my employees, agents, or other bona fide representatives via the security features provided herein.&nbsp; Upon termination of the employment of any user hereunder, I shall promptly delete that employee or representative as a user.&nbsp;
              <br />
              <br />REPUBLIC INDEMNITY provides information as a service to its Policyholders. The information and service provided via this facility is provided as is without any warranty, expressed or implied. Republic Indemnity is not responsible for any material linked to its site, whether or not linked by license.
            </b>
          </section>
        </div>
      </b-modal>
    </section>
  </div>
</template>

<script>
//import moment from "moment";
import { ValidateAccessToken } from "../utils/services";
import TypeLists from "../data/typelists";

export default {
  name: "validate",
  data: () => {
    return {
      isAgreement: false,
      webAgreement: false,
      isImageModalActive: false,
      country: "",
      state: "",
      policynbr: {
        name: "policynbr",
        label: "Enter your Republic Indemnity Policy Number (Numbers only):",
        value: "",
        type: "text",
        validate: {
          required: true,
          numeric: true,
          min: 7
        }
      },

      effdate: {
        name: "effdate",
        label: "Policy Effective Date:",
        value: new Date(),
        formatted: "",
        type: "date",
        validate: {
          required: true,
          date_format: "MM/dd/yyyy"
        }
      },
      authcode: {
        name: "authcode",
        label: "Enter your Web Access Code:",
        value: "",
        type: "password",
        validate: {
          required: true,
          min: 8,
          max: 9
        }
      },
      stateMap: TypeLists.States,
      countryList: TypeLists.CountriesObjs,
      formLoading: false
    };
  },
  created: function() {
    if (process.env.NODE_ENV === "development") {
      this.policynbr.value = "16374115";
      //   this.effdate.value = "2018-10-23";
      this.authcode.value = "291343800";
    }
  },
  computed: {
    isFormValid: function() {
      return !this.errors.all().length;
    }
  },
  methods: {
    policyNumberSet: function(e) {
      this.policynbr.value = e.target.value;
      this.policynbr.value = this.policynbr.value.replace(/[^\d]/g, "");
    },
    agreementModal() {
      this.$modal.open({
        parent: this,
        component: ModalForm,
        hasModalCard: true
      });
    },
    validate: function() {
      return this.$validator.validate().then(valid => {
        if (!valid) {
          console.warn("validate:reject");
          return Promise.reject();
        }
      });
    },
    togglePassword: function() {
      this.authcode.type =
        this.authcode.type === "password" ? "text" : "password";
    },
    onCancel: function() {
      this.$router.replace("/");
    },
    onSubmitValidation: function() {
      this.formLoading = true;

      this.validate()
        .then(() =>
          ValidateAccessToken({
            policynbr: this.policynbr.value,
            effdate: this.effdate.value,
            authcode: this.authcode.value
          })
        )
        .then(ValidationResult => {
          //          this.$router.replace("/register");
        })
        .catch(function(error) {
          if (error) window.alert(error);
        })
        .finally(_ => {
          this.formLoading = false;
        });
    }
  },
  watch: {
    "effdate.value": function(newVal) {
      this.effdate.formatted = newVal;
      if (!newVal) return;
      let date = moment(newVal, ["YYYY-MM-DD", "MM/DD/YYYY"], true);
      this.effdate.formatted = date.isValid()
        ? date.format("MM/DD/YYYY")
        : "Nan";
    }
  }
};
</script>